import EmptyHolder from 'components/EmptyHolder'
import {List as ImmutableList} from 'immutable'
import {LazyList} from 'modules/asyncCache/components/LazyList'
import React from 'react'
import {AutoSizer, CellMeasurer, CellMeasurerCache, List,} from 'react-virtualized'
import {NullAsDefault} from 'views/Shared'

const cache = new CellMeasurerCache({
  fixedWidth: true,
  defaultHeight: 200,
})

export const DocumentVirtualList = ({ data = [], renderItem = NullAsDefault }) => {
  const _data = Array.from(data ?? [])

  const list = ImmutableList(_data)

  const getItem = (index) => list.get(index % list.size)

  const rowRenderer = ({
    key,
    index,
    parent,
    style,
    isVisible,
    isScrolling,
  }) => (
    <CellMeasurer
      key={key}
      cache={cache}
      parent={parent}
      columnIndex={0}
      rowIndex={index}>
      {({ registerChild }) => (
        <div
          style={style}
          ref={registerChild}>
          {renderItem(getItem(index), index)}
        </div>
      )}
    </CellMeasurer>
  )
  return (
    <div style={{ height: '100vh' }}>
      <AutoSizer>
        {({ width, height }) => (
          <List
            width={width}
            height={height}
            rowCount={list.size}
            rowRenderer={rowRenderer}
            rowHeight={cache.rowHeight}
            deferredMeasurementCache={cache}
            noRowsRenderer={() => <EmptyHolder />}
          />
        )}
      </AutoSizer>
    </div>
  )
}

const DocumentLazyList = ({
  data = [],
  renderItem = NullAsDefault,
  onChange = (index, array) => {},
}) => {
  const _data = Array.from(data ?? [])
  const list = ImmutableList(_data)

  return (
    <React.Fragment>
      <LazyList
        withItem={(item, { index = 0, notifyChanges = NullAsDefault }) => ({
          offset: undefined,
          partialVisibility: true,
          onVisible: () => {
            onChange(index, list)
            notifyChanges()
          },
        })}>
        {list.map((item, index) => (
          <React.Fragment key={index}>{renderItem(item, index)}</React.Fragment>
        ))}
      </LazyList>
    </React.Fragment>
  )
}

export default DocumentLazyList
